import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ImageType from '@/Controls/Image';
import LabelType from '@/Controls/Label';
import ButtonViewModelType from '@/ViewModels/Controls/ButtonViewModel';
import EventHelper from '@/Utility/EventHelper';
import Utilities from "@/Utility/Utilities";

export default class Button extends Control {

    private Image = ComponentManager.getControl<typeof ImageType>('Image');
    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    protected jQueryControl: JQuery;
    private image: ImageType;
    private label: LabelType;

    public constructor(protected viewModel: ButtonViewModelType, protected element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<button>');

        EventHelper.bindClickEvent(this.jQueryControl, (openInNewWindow: boolean, event: JQuery.Event) => {
            if (!this.isDisposed && this.viewModel.isEnabled()) {
                this.viewModel.onClick(openInNewWindow, event);
            }
        }, this);

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'button',

            locator: this.viewModel.locator,

            click: () => { },

            enable: this.viewModel.isEnabled,

            visible: this.viewModel.isVisible,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            focus: this.viewModel.isFocusable,

            tooltip: this.viewModel.tooltip,

            styles: this.definePureComputed({
                read: () => {
                    var styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    var states = [];

                    if (this.viewModel.isPrimaryButton() === true) {
                        states.push('primary');
                    }

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            }),
            classes: ['noselect']
        });

        if (this.viewModel.image != null) {
            this.image = new this.Image(this.viewModel.image);
            const tuple = this.image.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            const tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        this.handleCustomStyles();
    }

    private handleCustomStyles() {
        const styleRules: Array<string> = [];
        if (!Utilities.isNullOrUndefined(this.viewModel.textColor()))
            styleRules.push(`color: ${this.viewModel.textColor()} !important;`);

        if (!Utilities.isNullOrUndefined(this.viewModel.backgroundColor()))
            styleRules.push(`background-color: ${this.viewModel.backgroundColor()} !important;`);

        if (!Utilities.isNullOrUndefined(this.viewModel.borderColor()))
            styleRules.push(`border-color: ${this.viewModel.borderColor()} !important;`);

        const identifier = 'custom_' + this.viewModel.identifier;
        this.jQueryControl.addClass(identifier);

        let css = `.${identifier} {`
        for (const rule of styleRules) {
            css += rule;
        }
        css += '}';

        if (!Utilities.isNullOrUndefined(this.viewModel.hoverColor())) {
            const hoverRule = `.${identifier}:hover { background: ${this.viewModel.hoverColor()} !important; }`
            css += hoverRule;
        }

        const style = document.createElement('style');
        style.appendChild(document.createTextNode(css));
        
        this.jQueryControl.append(style);
    }
}

ComponentManager.setControl('Button', Button, 'RADPresentation.HTMLClient.DefaultViewExtensions');